__turbopack_context__.v({
  "animate": "HomepageV2Animate-module-scss-module__J-VuYq__animate",
  "fadeLeft": "HomepageV2Animate-module-scss-module__J-VuYq__fadeLeft",
  "fadeRight": "HomepageV2Animate-module-scss-module__J-VuYq__fadeRight",
  "fadeUp": "HomepageV2Animate-module-scss-module__J-VuYq__fadeUp",
  "hpv2Blink": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2Blink",
  "hpv2DemoBounce": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2DemoBounce",
  "hpv2DemoFadeIn": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2DemoFadeIn",
  "hpv2DemoProgress": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2DemoProgress",
  "hpv2DemoScaleIn": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2DemoSlideIn",
  "hpv2FadeLeft": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2FadeLeft",
  "hpv2FadeRight": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2FadeRight",
  "hpv2FadeUp": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2FadeUp",
  "hpv2FloatA": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2FloatA",
  "hpv2FloatB": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2FloatB",
  "hpv2HeroFadeIn": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2PriceShimmer",
  "hpv2PulseDot": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2PulseDot",
  "hpv2ScaleUp": "HomepageV2Animate-module-scss-module__J-VuYq__hpv2ScaleUp",
  "scaleUp": "HomepageV2Animate-module-scss-module__J-VuYq__scaleUp",
  "visible": "HomepageV2Animate-module-scss-module__J-VuYq__visible",
});
